<template>
  <div :class="computedClass">
    <div class="mb-4">
      <span class="font-bold">Processamento Manual</span>
      <div class="flex flex-row gap-1">
        <v-select
          v-model="action"
          :options="actions"
          label="label"
          value="value"
          placeholder="Selecionar Ação"
          :reduce="(item) => item.value"
          style="width: 250px"
        ></v-select>
        <vs-button
          color="primary"
          type="border"
          :disabled="!action"
          @click="execute"
          class="font-bold"
          >Executar</vs-button
        >
        <vs-button
          icon="refresh"
          @click="reloadData"
          color="primary"
          type="border"
        />
      </div>
    </div>
    <vs-collapse type="border">
      <vs-collapse-item v-for="(item, index) in logs" :key="index">
        <div class="flex flex-row" slot="header">
          <span class="font-bold mr-4">{{ item.action }}</span>
          <vs-chip class="mr-3" :color="defineCorChipMaxpar(item.status)">{{
            item.status
          }}</vs-chip>
        </div>
        <div v-if="item.tries">
          <span class="font-bold">Tentativas: </span>
          <span>{{ item.tries }}</span>
        </div>
        <div v-if="item.syncDate">
          <span class="font-bold">Data de sincronização: </span>
          <span>{{ functions.formataDataHoraPadraoBR(item.syncDate) }}</span>
        </div>
        <vs-tabs class="mt-3" alignment="fixed">
          <vs-tab label="Payload">
            <div class="tab-text">
              <vue-json-pretty
                :path="'res'"
                :data="retornaJson(item.payload)"
              ></vue-json-pretty>
            </div>
          </vs-tab>
          <vs-tab label="Reposta">
            <div class="tab-text">
              <vue-json-pretty
                :path="'res'"
                :data="retornaJson(item.response)"
              ></vue-json-pretty>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty';
import vSelect from 'vue-select';
import 'vue-json-pretty/lib/styles.css';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';
import maxparApiService from '../../../../services/maxpar.api';
import { MAXPAR_MANUAL_ACTIONS } from '@/utils/constants';

export default {
  name: 'MaxparAssistanceIntegrationContent',
  props: ['logs', 'policy-id'],
  components: {
    VueJsonPretty,
    vSelect,
  },
  computed: {
    MAXPAR_MANUAL_ACTIONS() {
      return MAXPAR_MANUAL_ACTIONS;
    },
    computedClass() {
      const hasLogs = Array.isArray(this.logs) && this.logs.length === 0;
      return hasLogs ? 'pb-24' : 'pb-4';
    },
  },
  data() {
    return {
      functions,
      actions: [
        MAXPAR_MANUAL_ACTIONS.CREATE,
        MAXPAR_MANUAL_ACTIONS.CANCEL,
        MAXPAR_MANUAL_ACTIONS.CHANGE,
      ],
      action: null,
    };
  },
  methods: {
    defineCorChipMaxpar(status) {
      const colorsByStatus = {
        ['Não Sinconizada']: 'warning',
        ['Falha na Sincronização']: 'danger',
        ['Sincronizada']: 'success',
      };
      return colorsByStatus[status];
    },
    retornaJson(str) {
      return typeof str === 'string' ? JSON.parse(str) : '';
    },
    async execute() {
      this.$vs.loading();
      const payload = {
        policyId: this.policyId,
        action: this.action,
      };

      try {
        await maxparApiService.executeAssistance(payload);
        notify.notifySuccess(this.$vs, 'Registro processado com sucesso.');
        this.reloadData();
      } catch (error) {
        notify.notifyFail(this.$vs, 'Erro ao processar registro.');
      } finally {
        this.$vs.loading.close();
      }
    },
    reloadData() {
      this.$emit('reload');
    },
  },
};
</script>
<style></style>
